module.exports = __webpack_public_path__ + "static/img/display_lcd_azul_16x2_i2c-2.7f7efce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/display_lcd_azul_16x2_i2c-2.svg
// module id = WYE2
// module chunks = 0